import { useCallback, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@/integrations/supabase/types';

type Profile = Tables<'profiles'>;

export function useProfileState() {
  const [profile, setProfile] = useState<Profile | null>(null);

  const fetchProfile = useCallback(async (userId: string): Promise<Profile | null> => {
    const { data } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', userId)
      .maybeSingle();
    setProfile(data);
    return data;
  }, []);

  const resetProfile = useCallback(() => {
    setProfile(null);
  }, []);

  return {
    profile,
    setProfile,
    fetchProfile,
    resetProfile,
  };
}
